<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Clave</th>
                <th :class="StyleTh">Tratamiento Int.</th>
                <th :class="StyleTh">Tratamiento Ext.</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
                
			</template>

            <template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Clave}}</p></td>
                    <td><p :class="StyleTd">{{lista.ReqTratInt}}</p></td>    
                    <td><p :class="StyleTd">{{lista.ReqTratExt}}</p></td>
                                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdArticuloWeb" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">

                                <template v-if="segurity.ConfigMaterials">
                                    <button v-if="ObjTipoLente.Proceso == 1" @click="viewConfMateriales(lista)" class="btn btn-secondary btn-icon btn-sm rounded me-2" v-b-tooltip.hover.left title="Configurar Materiales" >
                                        <i class="fas fa-shapes"></i>
                                    </button>

                                    <button v-else @click="viewConfGraduaciones(lista)" class="btn btn-secondary btn-icon btn-sm rounded me-2" v-b-tooltip.hover.left title="Configurar Graduaciones" >
                                        <i class="fas fa-glasses"></i>
                                    </button>
                                </template>

                                <template v-if="segurity.ConfigDiscounts">
                                    <button @click="viewDescuentosRecubrimiento(lista)" class="btn btn-warning btn-icon btn-sm rounded me-2" v-b-tooltip.hover.left title="Configurar Desc. Recubrimientos" >
                                        <i class="fas fa-shield"></i>
                                    </button>
                                </template>

                                <template v-if="segurity.PermitWarranty">
                                    <button @click="viewConfiguracionGarantias(lista)" class="btn btn-success btn-icon btn-sm rounded me-2" v-b-tooltip.hover.left title="Garantias Permitidas" >
                                        <i class="fas fa-award"></i>
                                    </button>
                                </template>

                            </template>
						</CBtnAccion>
					</td>
                    
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="7"></CSinRegistros>
			</template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalDescuentos" :poBtnSave="oBtnSaveDescuentos">
			<template slot="Form">
				<FormDescuentos :poBtnSave="oBtnSaveDescuentos"></FormDescuentos>
            </template>
		</CModal>
        
        <CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
			<template slot="Form">
				<Garantias :poBtnSave="oBtnSave2"></Garantias>
			</template>
		</CModal>
    </div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
import Form from '../articulosweb/Form.vue';
import FormDescuentos from '../articulosxrecubrimientosdescuentos/Form.vue';
import Garantias from '../articulosweb/FormGarantias.vue';
const EmitEjecuta = 'seccionArticulosWeb';
const EmitEjecuta2 = 'seccionArticulosWebDescuentos';
const EmitEjecuta3 = 'seccionGarantias';

export default{
    name:'ArticulosWeb',
    props:['pObjTipoLente','pObjSublinea'],
    components:{
        Form,
        Garantias,
        FormDescuentos
    },
    data(){
        return{
            ConfigList:{
                Title: 'Listado de Articulos ',
                IsModal: true,
                ShowLoader: true,
                BtnReturnShow: true,
                EmitSeccion: EmitEjecuta,
                ShowTitleFirst: false,
                TitleFirst: '',
                Obj:{}
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 10,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Artículo Web",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'lg'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },

            ConfigModalDescuentos:{
                ModalTitle: "Descuentos de Recubrimientos",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                ModalSize:'lg'
            },

            oBtnSaveDescuentos: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },

            ConfigModal2:{
                ModalTitle: "Garantias Por Artículo Web",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta3,
                ModalSize:'lg'
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },

            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            ListaHeader: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjTipoLente:{},
            ObjSublinea:{},
            OrigenMenu: '',
        }
    },
    methods:{
        async Lista(){
            this.ConfigList.ShowLoader=true;
            await this.$http.get('articulosweb',{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdTipoLente: this.ObjTipoLente.IdTipoLente,
                    IdSublinea:this.ObjSublinea.IdSublinea
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('articulosweb/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar() {
            switch (this.OrigenMenu) {
                case 'TpLente':
                this.$router.push({name:'tiposlentes',params:{}});
                    break;

                case 'Sublinea':
                    this.$router.push({name:'tipolentexsublinea',params:{pObjEnviado:this.ObjTipoLente}});
                    break;
            }
            
        },
        viewConfMateriales(item){
            this.$router.push({name:'articulosxmateriales',params:{ pObjArticuloWeb:item}});
        },
        
        viewConfGraduaciones(item){
            this.$router.push({name:'articulosxgraduaciones',params:{ pObjArticuloWeb:item}});
        },

        viewDescuentosRecubrimiento(item) {
           this.bus.$emit('NewModal_'+EmitEjecuta2,0,item);

        },
        
        viewConfiguracionGarantias(item)
        {
            this.bus.$emit('NewModal_'+this.ConfigModal2.EmitSeccion,item);
        }
    },
    created(){
        if(this.pObjTipoLente != undefined){
            sessionStorage.setItem('objTipoLente',JSON.stringify(this.pObjTipoLente));
        }
        if(this.pObjSublinea != undefined){
            sessionStorage.setItem('objSublinea',JSON.stringify(this.pObjSublinea));
        }
        this.ObjTipoLente = JSON.parse(sessionStorage.getItem('objTipoLente'));
        this.ObjSublinea = JSON.parse(sessionStorage.getItem('objSublinea'));

        this.ConfigList.Obj.IdTipoLente=this.ObjTipoLente.IdTipoLente;
        this.ConfigList.Obj.IdSublinea=this.ObjSublinea.IdSublinea;

        // NOMBRE DE TITULO LISTADO
        if(sessionStorage.getItem('OrigenMenu') != undefined) {
            this.OrigenMenu = 'Sublinea';

            if(sessionStorage.getItem('OrigenMenu') == 'Sublinea') {
                this.ConfigList.Title = this.ConfigList.Title+' de Sublinea: '+this.ObjSublinea.Nombre;
            }else if (sessionStorage.getItem('OrigenMenu') == 'TpLente') {
                this.OrigenMenu = 'TpLente';
                this.ConfigList.Title = this.ConfigList.Title+' para: '+this.ObjTipoLente.Nombre;
            }

        }else {
            if(this.ObjSublinea.IdSublinea == 0){
            this.ConfigList.Title = this.ConfigList.Title+' para: '+this.ObjTipoLente.Nombre;
            }else if(parseInt(this.ObjSublinea.IdSublinea) > 0){
                this.ConfigList.Title = this.ConfigList.Title+' de Sublinea: '+this.ObjSublinea.Nombre;
            }
        }
        
        
        
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('NewModal_'+EmitEjecuta2);
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted(){
        this.Lista();

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>